export default "__VITE_ASSET__DK4OQrfK__"